<!-- only_desktop -->
<div class="d-none d-md-block">
    <!-- <div class="container-fluid jc-center pb-2"> -->
    <div fxLayoutAlign="center center" *ngIf="what==='show'">
        <div class="container justify-content-center mb-4">
            <div>
                <mat-grid-list [cols]="getGridCols()" rowHeight="18rem" gutterSize="40px"
                    class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                    <mat-grid-tile *ngFor="let card of whyTopRatedCardData; let i=index"
                        [style.background-color]="themedata.secondarybg" class style="border-radius: 2rem;">

                        <div class="RapidMarketEntry">
                            <div class="grid-item" [routerLink]="card?.routerLink1">
                                <div class="image_container">
                                    <img [appLazyLoadImage]="'../../assets/images/'+card?.image" class="image">
                                    <p class="title_content lh-sm {{fontData.name}} text-center align-content-center">{{
                                        card?.title }}</p>
                                    <div class="overlay">
                                        <div class="text">
                                            <button [style.background-color]="themedata.primarytheme"
                                                [style.color]="themedata.cardtext" class="btn btn-sm image_btn {{fontData.name}}"
                                                [routerLink]="card?.routerLink1">ReadMore...</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </mat-grid-tile>
                </mat-grid-list>
            </div>
        </div>
        <!-- </div> -->
    </div>
</div>

<!-- only_mobile -->
<div class="col-sm-12 justify-content-sm-center d-md-none d-lg-none pb-2">
    <div *ngIf="what==='show'" class="col-sm-12 justify-content-sm-center">
        <mat-grid-list [cols]="getGridCols()" rowHeight="18rem" gutterSize="20px">
            <mat-grid-tile *ngFor="let card of whyTopRatedCardData; let i=index"
                [style.background-color]="themedata.secondarybg" class="grid-tile">

                <div class="RapidMarketEntry" [routerLink]="card?.routerLink1">
                    <div class="image-container">
                        <img [appLazyLoadImage]="'../../assets/images/'+card?.image" class="image">
                    </div>
                    <div class="h3 text-center">
                        <p class="fs-1 fw-bold lh-base">{{ card?.title }}</p>
                        <button [style.background-color]="themedata.primarytheme" [style.color]="themedata.cardtext"
                            class="btn btn-sm {{fontData.name}}" [routerLink]="card?.routerLink1">ReadMore...</button>
                    </div>
                </div>

            </mat-grid-tile>
        </mat-grid-list>
    </div>
</div>

<!-- <div *ngIf="what==='hide'" class="whatareweoffering_1">
    <button (click)="pre()" class="my" aria-label="Previous" type="button" [disabled]="currentIndex <= 0">
        <mat-icon class="arrowicon" style="color: #fff; font-weight: 600;">keyboard_arrow_left</mat-icon>
    </button>
    <div *ngFor="let item of displayedwhatweare" class="RapidMarketEntry">
        <div class="image-container">
            <img class="image" [appLazyLoadImage]="'../../assets/images/'+item?.image" />
        </div>
        <h3>{{ item?.title }}</h3>
        <div class="overlay">
            <div class="text">
                <button [style.background-color]="themedata.primarytheme" [style.color]="themedata.color"
                    class="image_btn" routerLink="{{ item?.routerLink1 }}">ReadMore...</button>
            </div>
        </div>

    </div>
    <button (click)="next( )" class="my" aria-label="next" type="button"
        [disabled]="currentIndex >= whyTopRatedCardData?.length - length">
        <mat-icon class="arrowicon" style="color: #fff; font-weight: 600;">keyboard_arrow_right</mat-icon>
    </button>
</div> -->